import DwseProcedure from './vue/dwse-procedure.vue';
import DwseProcedureStep from './vue/dwse-procedure-step.vue';

export function install(Vue) {
  Vue.component('dwse-procedure', DwseProcedure);
  Vue.component('dwse-procedure-step', DwseProcedureStep);
}

export { DwseProcedure, DwseProcedureStep };

const plugin = {
  version: require('../package.json').version,
  install
};

export default plugin;
